import React from "react";

/**
 * AgeGroupSelector Component
 *
 * Multi-select component for choosing target age groups for ministry.
 * Displays checkboxes for each age group with consistent styling.
 *
 * @param {string} label - Label text to display above the selector
 * @param {array} value - Array of selected age group values
 * @param {function} onChange - Handler for selection changes (receives array of selected values)
 * @param {string} helperText - Optional helper text below label
 */
const AgeGroupSelector = ({
  label,
  value = [],
  onChange,
  helperText,
}) => {
  const ageGroups = [
    { value: "children", label: "Children (0-11)" },
    { value: "youth", label: "Youth (11-18)" },
    { value: "young-adults", label: "Young Adults (18-30)" },
    { value: "adults", label: "Adults (30+)" },
    { value: "all-ages", label: "All Ages" },
  ];

  const handleToggle = (groupValue) => {
    const newValue = value.includes(groupValue)
      ? value.filter((v) => v !== groupValue)
      : [...value, groupValue];
    onChange(newValue);
  };

  return (
    <div>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            marginBottom: "8px",
          }}
        >
          {label}
        </label>
      )}
      {helperText && (
        <p
          style={{
            fontSize: "13px",
            color: "#737373",
            margin: "0 0 12px 0",
          }}
        >
          {helperText}
        </p>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {ageGroups.map((group) => (
          <label
            key={group.value}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 16px",
              backgroundColor: value.includes(group.value) ? "#fafafa" : "#fff",
              border: value.includes(group.value)
                ? "2px solid #1a1a1a"
                : "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              userSelect: "none",
            }}
            onMouseEnter={(e) => {
              if (!value.includes(group.value)) {
                e.currentTarget.style.borderColor = "#a3a3a3";
                e.currentTarget.style.backgroundColor = "#fafafa";
              }
            }}
            onMouseLeave={(e) => {
              if (!value.includes(group.value)) {
                e.currentTarget.style.borderColor = "#e5e5e5";
                e.currentTarget.style.backgroundColor = "#fff";
              }
            }}
          >
            <input
              type="checkbox"
              checked={value.includes(group.value)}
              onChange={() => handleToggle(group.value)}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                accentColor: "#1a1a1a",
              }}
            />
            <span
              style={{
                fontSize: "15px",
                color: "#1a1a1a",
                fontWeight: value.includes(group.value) ? "500" : "400",
              }}
            >
              {group.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default AgeGroupSelector;
